import React from 'react'
import ChannelUI from '@sendbird/uikit-react/Channel/components/ChannelUI'
import { useChannelContext } from '@sendbird/uikit-react/Channel/context'
import { CustomizedMessage } from './CustomizedMessage'
import { RequestResponse } from '../../types/requests/responses/request-response'
import Image from 'next/image'
import { parseUsers } from '../../common/utils/lobby.utils'
import { useUser } from '../../hooks/users/useUser'
import { UserResponse } from '../../types/users/user-response'
import Message from '@sendbird/uikit-react/Channel/components/Message'

type Props = {
  request?: RequestResponse
  customer?: UserResponse | null
}

export default function ChannelUISection({ request, customer }: Props) {
  const { user: currentUser } = useUser()
  const channelState = useChannelContext()
  channelState.isReactionEnabled = false

  return (
    <ChannelUI
      renderChannelHeader={() => {
        return CustomizedChannelHeader({ request, currentUser })
      }}
      // @ts-ignore
      renderMessage={(props: any) => {
        if (props?.message?.sender?.userId === 'TapInChatBot') {
          if (props?.message?.customType === 'request') {
            return CustomizedMessage(props)
          }
        }
        return <Message {...props} />
      }}
    />
  )
}

type CustomizedChannelHeaderProps = {
  request?: RequestResponse
  currentUser?: UserResponse | null
}

export function CustomizedChannelHeader({
  request,
  currentUser,
}: CustomizedChannelHeaderProps) {
  const users = parseUsers(request?.lobby?.userLobby)?.filter((user) => {
    return user?.id !== currentUser?.id
  })

  return (
    <div className={'flex flex-row items-center gap-3 px-5 py-3.5'}>
      <div className={'relative h-7 w-7 shrink-0'}>
        <Image
          fill={true}
          src={
            users[0]?.avatar?.imageUrl ??
            process.env.NEXT_PUBLIC_DEFAULT_AVATAR_URL!
          }
          className={'rounded-full object-cover'}
          alt={'Teammate avatar'}
        />
      </div>

      <p className={'text-body-normal w-full truncate pr-20 text-white'}>
        {users
          ?.map((user) => {
            return user?.username ?? user?.fullName ?? ''
          })
          ?.join(',')}
      </p>
    </div>
  )
}
